'use strict';

angular.module('ListAccessRequestControllers')

.controller('SideBarUserAccessRequestCtrl', ['$scope', '$state', '$stateParams', '$interval', 'nbRequests', 'custodian', 'authenticatedUser', 'userAccessRequestService', function ($scope, $state, $stateParams, $interval, nbRequests, custodian, authenticatedUser, userAccessRequestService) {

    $scope.custodian = _.isNull(custodian) ? '' : custodian;

    // Unassigned or My Assigned Requests
    $scope.context = {};
    $scope.context.withMyAssignedRequests = false;
    $scope.context.withUnAssignedRequests = false;

    if ($state.is('userAccessRequest.request.assignedToMe')) {
        $scope.context.withMyAssignedRequests = true;
        $scope.context.withUnAssignedRequests = false;
    }

    if ($state.is('userAccessRequest.request.unAssigned')) {
        $scope.context.withMyAssignedRequests = false;
        $scope.context.withUnAssignedRequests = true;
    }

    $scope.toggleMyAssignedRequests = function () {
        $scope.context.withMyAssignedRequests = !$scope.context.withMyAssignedRequests;
        $scope.context.withUnAssignedRequests = false;

        if (!_.isUndefined($scope.nbMyAssignedRequests)) {
            $scope.nbMyAssignedRequests.WithChanges = false;
        }

        if ($scope.context.withMyAssignedRequests) {
            $state.go('userAccessRequest.request.assignedToMe');
        }
        else {
            $state.go('userAccessRequest.request.all');
        }
    }

    $scope.toggleUnAssignedRequests = function () {
        $scope.context.withUnAssignedRequests = !$scope.context.withUnAssignedRequests;
        $scope.context.withMyAssignedRequests = false;

        if (!_.isUndefined($scope.nbUnAssignedRequests)) {
            $scope.nbUnAssignedRequests.WithChanges = false;
        }

        if ($scope.context.withUnAssignedRequests) {
            $state.go('userAccessRequest.request.unAssigned');
        }
        else {
            $state.go('userAccessRequest.request.all');
        }
    }

    // By Status
    $scope.statusActions = [
        {
            id: 'allStatus',
            title: 'All Status',
            icon: 'fa fa-inbox',
            srefActive: function () { return $state.includes('userAccessRequest.request.all'); },
            sref: 'userAccessRequest.request.all'
        },
        {
            id: 'notStarted',
            title: 'Not Started',
            icon: 'fa fa-flag',
            label: 'label label-gray',
            sref: 'userAccessRequest.request.notStarted'
        },
        {
            id: 'draft',
            title: 'Draft',
            icon: 'fa fa-pencil-square-o',
            label: 'label label-orange',
            sref: 'userAccessRequest.request.draft'
        },
        {
            id: 'underReview',
            title: 'Under Review',
            icon: 'fa fa-eye',
            label: 'label label-purple',
            sref: 'userAccessRequest.request.underReview'
        },
        {
            id: 'pendingAuthorization',
            title: 'Pending Authorization',
            icon: 'fa fa-key',
            label: 'label label-orange',
            sref: 'userAccessRequest.request.pendingAuthorization'
        },
        {
            id: 'postDated',
            title: 'Post Dated',
            icon: 'fa fa-calendar',
            label: 'label label-gray',
            sref: 'userAccessRequest.request.postDated'
        },
        {
            id: 'toProcess',
            title: 'To Process',
            icon: 'fa fa-truck',
            label: 'label label-green',
            srefActive: function () { return $state.includes('userAccessRequest.request.toProcess'); },
            sref: 'userAccessRequest.request.toProcess',
            srefOpts: {
                custodian: $scope.custodian
            }
        },
        {
            id: 'completed',
            title: 'Completed',
            icon: 'fa fa-check-square-o',
            sref: 'userAccessRequest.request.completed'
        },
        {
            id: 'onHold',
            title: 'On Hold',
            icon: 'fa fa-pause on-hold',
            sref: 'userAccessRequest.request.onHold'
        }
    ];

    // By Request Type
    $scope.typeActions = [
        {
            id: 'all',
            title: 'All Types',
            icon: 'fa fa-inbox',
            srefActive: function () {
                if (!$state.includes('userAccessRequest.request.**')) return false;
                return $state.params.type === 'all' || _.isUndefined($state.params.type);
            }
        },
        {
            id: 'normal',
            title: 'Normal Requests',
            icon: 'fa fa-thumb-tack',
            srefActive: function () {
                if (!$state.includes('userAccessRequest.request.**')) return false;
                return $state.params.type === 'normal';
            }
        },
        {
            id: 'arrival',
            title: 'Arrivals',
            icon: 'fa fa-sign-in',
            srefActive: function () {
                if (!$state.includes('userAccessRequest.request.**')) return false;
                return $state.params.type === 'arrival';
            }
        },
        {
            id: 'departure',
            title: 'Departures',
            icon: 'fa fa-plane',
            srefActive: function () {
                if (!$state.includes('userAccessRequest.request.**')) return false;
                return $state.params.type === 'departure';
            }
        },
        {
            id: 'transfer',
            title: 'Transfers',
            icon: 'fa fa-exchange',
            srefActive: function () {
                if (!$state.includes('userAccessRequest.request.**')) return false;
                return $state.params.type === 'transfer';
            }
        },
        {
            id: 'accessreview',
            title: 'Access Review',
            icon: 'fa fa-eye',
            srefActive: function () {
                if (!$state.includes('userAccessRequest.request.**')) return false;
                return $state.params.type === 'accessreview';
            }
        }
    ];

    // By Custodian
    $scope.custodianActions = [
        {
            id: 'AllCustodians',
            title: 'All Custodians',
            sref: 'userAccessRequest.request.toProcess({ custodian: "" })'
        },
        {
            id: 'id-custodian-BtgAccessMgmt',
            title: 'BTG Access Management',
            icon: 'fa fa-inbox',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-BtgAccessMgmt" })'
        },
        {
            id: 'id-custodian-compliance',
            title: 'Compliance',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-compliance" })'
        },
        {
            id: 'id-custodian-treasury',
            title: 'Treasury',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-treasury" })'
        },
        {
            id: 'id-custodian-corpFinance',
            title: 'Corp. Finance',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-corpFinance" })'
        },
        {
            id: 'id-custodian-marketData',
            title: 'Market Data',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-marketData" })'
        },
        {
            id: 'id-custodian-poms',
            title: 'POMS',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-poms" })'
        },
        {
            id: 'id-custodian-hritapplications',
            title: 'HR',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-hritapplications" })'
        },
        {
            id: 'id-custodian-itInfra',
            title: 'IT Infrastructure',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-itInfra" })'
		},
		{
			id: 'id-custodian-itsecurityoperations',
            title: 'Information Security Operations',
			sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-itsecurityoperations" })'
		},
	    {
		    id: 'id-custodian-legal',
		    title: 'Legal',
		    sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-legal" })'
        },
        {
            id: 'id-custodian-fasPhysicalAccess',
            title: 'FAS Physical Access',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-fasPhysicalAccess" })'
        },
        {
            id: 'id-custodian-userServices',
            title: 'User Services',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-userServices" })'
        },
        {
            id: 'id-custodian-hrBenefitsWellness',
            title: 'HR - Benefits & Wellness',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-hrBenefitsWellness" })'
        },
        {
            id: 'id-custodian-dba',
            title: 'DBA',
            sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-dba" })'
		},
		{
			id: 'id-custodian-dataGovernance',
			title: 'Data Governance',
			sref: 'userAccessRequest.request.toProcess({ custodian: "id-custodian-dataGovernance" })'
		}
    ];

    // Set Nb Requests
    $scope.setNbRequests = function (newNbRequests) {

        // Check changes
        if (!_.isUndefined($scope.nbRequests))
        {
            for (var byFeature in newNbRequests) {
                // check also if property is not inherited from prototype
                if (newNbRequests.hasOwnProperty(byFeature)) {
                    if ($scope.nbRequests[byFeature].WithChanges === true) {
                        newNbRequests[byFeature].WithChanges = true;
                    }
                    else if (newNbRequests[byFeature].MaxUpdateTimestampTicks > $scope.nbRequests[byFeature].MaxUpdateTimestampTicks) {
                        newNbRequests[byFeature].WithChanges = true;
                    }
                }
            }
        }

        $scope.nbRequests = newNbRequests;
        $scope.newChangesInSeconds = $scope.nbRequests.assignedToMe.RefreshInSecondsToRefreshList;
        $scope.nbMyAssignedRequests = $scope.nbRequests.assignedToMe;
        $scope.nbUnAssignedRequests = $scope.nbRequests.unAssigned;

        _.map($scope.statusActions, function (statusAction) {
            statusAction.nbRequests = $scope.nbRequests[statusAction.id];

            if (_.isUndefined(statusAction.srefActive)) {
                statusAction.srefActive = function () {
                    return $state.is(statusAction.sref);
                }
            }

            if (_.isFunction(statusAction.toShow)) statusAction.toShow = statusAction.toShow();
            else statusAction.toShow = true;
        });
    }
    $scope.setNbRequests(nbRequests);

    /* Show or not filters */
    $scope.setFilterType = function (idFilter) {
        $stateParams.type = idFilter;
        $state.go($state.current.name, $stateParams);
    }

    $scope.backToLookupRequests = function () {
        $scope.context.withMyAssignedRequests = false;
        $state.go('userAccessRequest.request.all');
    }

    var fnWithFilterStatus = function (stateName) {
        if ($scope.context.withMyAssignedRequests) return false;
        if (stateName === 'userAccessRequest.request.lookupEmployee') return false;
        if (stateName === 'userAccessRequest.request.byEmployeeId') return false;
        return true;
    };
    $scope.withFilterStatus = fnWithFilterStatus($state.current.name);

    var fnWithByCustodian = function (stateName) {
        return stateName === 'userAccessRequest.request.toProcess';
    };
    $scope.withByCustodian = fnWithByCustodian($state.current.name);

    $scope.withFilterType = $scope.withFilterStatus;

    var fnWithBackToLookupRequests = function (stateName, stateParams) {
        if (stateName === 'userAccessRequest.request.lookupEmployee') return true;
        if (stateName === 'userAccessRequest.request.byEmployeeId') return true;
        if (stateName !== 'userAccessRequest.request.all') return true;
        if (stateParams.type != 'all') return true;
        return false;
    }
    $scope.withBackToLookupRequests = fnWithBackToLookupRequests($state.current.name, $state.params);

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        $scope.withFilterStatus = fnWithFilterStatus(toState.name);
        $scope.withByCustodian = fnWithByCustodian(toState.name);
        $scope.withFilterType = $scope.withFilterStatus;
        $scope.withBackToLookupRequests = fnWithBackToLookupRequests(toState.name, toParams);
    });

    // New changes
    $scope.newChanges = function () {
        if (angular.isDefined($scope.stopNewChanges)) return;

        $scope.stopNewChanges = $interval(function () {
            userAccessRequestService.countRequests().then($scope.setNbRequests);
        }, $scope.newChangesInSeconds * 1000);
    };
    $scope.newChanges();

    $scope.$on('$destroy', function () {
        if ($scope.stopNewChanges) $interval.cancel($scope.stopNewChanges);
    });

    // Refresh
    $scope.reloadRoute = function () {
        $state.reload();
    }

    $scope.goToAction = function (action) {
        if (!_.isUndefined(action.nbRequests)) {
            action.nbRequests.WithChanges = false;
        }

        if(_.isUndefined(action.srefOpts)) {
            $state.go(action.sref);
        }
        else {
            $state.go(action.sref, action.srefOpts);
        }
    }

    $scope.goToLookupEmployee = function () {
        $scope.context.withMyAssignedRequests = false;
        $scope.context.withUnAssignedRequests = false;

        $state.go('userAccessRequest.request.lookupEmployee');
    }
}]);

